<template>
	<div class="report-form-header clearfix">
		<div class="report-form-name fl-l">
			<i class="report-icon"></i>{{orderType}}
		</div>
		<div class="report-form-title fl-l">报表首页</div>
		<div class="report-form-title fl-l">
			<el-dropdown v-if="menu.length > 0" trigger="click" @command="handleCommand">
				<span class="title-drop">
					业务报表
					<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item
						v-for="item in menu.slice(0,7)"
						:key="item.key"
						v-show="item.show"
						:command="item">
						{{item.label}}
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<div v-else>
				<span class="title-drop">
					业务报表
					<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
			</div>
		</div>
		<div class="report-form-title fl-l">
			<el-dropdown trigger="click" @command="handleCommand">
				<span class="title-drop">
					交易报表
					<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item
						v-for="item in menu.slice(12, 16)"
						:key="item.key"
						v-show="item.show"
						:command="item">
						{{item.label}}
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
		<div class="report-form-title fl-l" v-if="reconciliationShow">
			<el-dropdown trigger="click" @command="handleCommand">
				<span class="title-drop">
					对账报表
					<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item
						v-for="item in menu.slice(16, 17)"
						:key="item.key"
						v-show="item.show"
						:command="item">
						{{item.label}}
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
		<div class="report-form-title fl-l" style="width:130px;">
			<el-dropdown trigger="click" @command="handleCommand">
				<span class="title-drop">
					营销活动报表
					<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item
						v-for="item in menu.slice(17)"
						:key="item.key"
						v-show="item.show"
						:command="item">
						{{item.label}}
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
export default {
	name: 'SettingMenu',
	computed: {
		...mapState([
			'orderType',
			'reportid',
			'orderMenu',
			'reportAuth'
		])
		// enabelMenu () {
		// 	// let menu = this.orderMenu.filter((item) => {
		// 	// 	if (this.orderType === '商户报表') {
		// 	// 		return item.key !== this.reportid && this.reportAuth[this.reportid] === true
		// 	// 	} else {
		// 	// 		return item.key !== this.reportid
		// 	// 	}
		// 	// })
		// 	// return menu
		// 	// this.checkSmallCategory().then(res => {
		// 	// 	console.log(res)
		// 	// })
		// 	return this.orderMenu
		// }
	},
	data () {
		return {
			reconciliationShow: false,
			idArr: [
				'715235793077010432',
				'1091656168016838656',
				'720926033196351488',
				'1091735537590599680',
				'1184447491089760256'
			],
			menu: [],
			prepaymentdefaultaccount: 0
		}
	},
	created () {
		this.$store.dispatch('requestPost', {
			url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
		}).then(res => {
			this.prepaymentdefaultaccount = res.prepaymentdefaultaccount
		})
		this.getAuthority('09_0001_0000_00,09_0003_0000_00,09_0004_0000_00').then((res) => {
			this.getSyscodeid()
		})
	},
	methods: {
		handleCommand (item) {
			let app = window.sessionStorage.getItem('app')
			if (app === 'scm8') {
				let params = {
					app: 'jsd',
					action: 'goBlank',
					data: {
						path: 'reportform/' + item.path,
						query: '',
						id: '11',
						title: item.label
					}
				}
				window.parent.postMessage(params, '*')
			} else {
				this.$fxGoBlank(item.path, this.$router)
			}
		},
		getAuthority (pid) {
			return new Promise((resolve, reject) => {
				let params = {
					pId: pid
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
					data: params
				}).then(res => {
					if (res.result === true) {
						let a = res.data
						let menu = this.orderMenu
						for (let i = 0; i < a.length; i++) {
							for (let j = 0; j < menu.length; j++) {
								if (a[i] === menu[j].authority) {
									menu[j].show = true
								}
								if (menu[j].path === 'OrderPayDetail' && this.prepaymentdefaultaccount === 1) {
									menu[j].show = false
								}
							}
						}
						this.menu = menu
						resolve()
						// console.log(menu)
					}
				})
			})
		},
		getSyscodeid () {
			let formData = new FormData()
			formData.append('funname', 'verifyamount,ordercreditlimit')
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/organ/customized`,
				data: formData
			}).then(res => {
				if (res.result) {
					let syscodeid = window.sessionStorage.getItem('entid')
					this.reconciliationShow = res.data.verifyamount.includes(syscodeid)
					if (res.data.ordercreditlimit) {
						this.menu.forEach(item => {
							if (item.path === 'orderPay' && res.data.ordercreditlimit.includes(syscodeid)) {
								item.show = true
							}
						})
					}
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
@import '~$assets/stylus/varsty.styl'
.report-form-header {
	font-size: 16px;
	font-weight:700;
	padding:20px
	border-bottom: 1px solid #eee;
	.report-form-name {
		background-color:$fxDefaultColor
		color:#fff
		width: 135px;
		height: 32px;
		line-height: 32px;
		position:relative
		&:after {
			content: '';
			display: block;
			width: 0;
			height: 0;
			position: absolute;
			border-style: solid;
			border-width: 16px 12px;
			border-color:  transparent transparent $fxDefaultColor $fxDefaultColor
			top: 0;
			right: -24px;
		}
		.report-icon{
			display: inline-block;
			margin-right: 10px;
			width: 15px;
			height: 15px;
			vertical-align: middle
			background-repeat:no-repeat
			background-position: center
			background-size: cover
			background-image:url('../../../assets/images/icon/reportform/report-form-name-icon.png')
		}
	}
	.report-form-title {
		width: 125px;
		height: 32px;
		line-height: 32px;
		margin-left:50px
	}
	.title-drop {
		font-size:16px
	}
}
</style>
